"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "readConfigFile", {
    enumerable: true,
    get: function() {
        return readConfigFile;
    }
});
const _cosmiconfig = require("cosmiconfig");
const _workspacetools = require("workspace-tools");
const ConfigModuleName = "lage";
async function readConfigFile(cwd) {
    // Verify presence of git
    const root = (0, _workspacetools.getWorkspaceRoot)(cwd);
    if (!root) {
        throw new Error("This must be called inside a codebase that is part of a JavaScript workspace.");
    }
    // Search for lage.config.js file
    const configExplorer = await (0, _cosmiconfig.cosmiconfig)(ConfigModuleName);
    const results = await configExplorer.search(root ?? cwd);
    return results?.config || undefined;
}
